import 'css-chunksrc/client/pages/searchPage/styles.scss';export default {
  "searchPage": "_searchPage_1jkn4_1",
  "header": "_header_1jkn4_8",
  "title": "_title_1jkn4_17",
  "profileNavigation": "_profileNavigation_1jkn4_23",
  "main": "_main_1jkn4_33",
  "filters": "_filters_1jkn4_40",
  "searchResults": "_searchResults_1jkn4_45"
};